import { render, staticRenderFns, recyclableRender, components } from "./distr.vue?vue&type=template&id=035c9914&"
var renderjs
import script from "./distr.vue?vue&type=script&lang=js&"
export * from "./distr.vue?vue&type=script&lang=js&"
import style0 from "./distr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/order/confirm-order/distr.vue"
export default component.exports